import { Button } from '@montugroup/design-system';
import { styled, Toolbar } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';

import useCustomer from '@/hooks/user/useCustomer';
import { PATIENT_ORDERS_ROUTE, PATIENT_REFILL_ROUTE } from '@/routes/route-paths';
import { alpha } from '@mui/material/styles';
import { PartnerContainer as Container } from './PortalPartner.styles';

const PartnerHeaderContainer = styled(Toolbar)(({ theme }) => ({
  background: theme.palette.primary.main,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const PartnerButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-sizeMedium.MuiButton-outlinedSecondary:not(.Mui-disabled):not(.Mui-focusVisible):not(:hover)': {
    color: theme.palette.secondary.main,
  },
  '&.MuiButton-outlinedSecondary:not(.Mui.disabled):not(.Mui-focusVisible):hover': {
    color: theme.palette.secondary.main,
    background: `${alpha(theme.palette.secondary.main, 0.25)}`,
  },
}));

function PartnerHeader() {
  const location = useLocation();
  const { Logo: PartnerLogo } = usePortalPartnerBrand();
  const { data: customer, isLoading } = useCustomer();
  const isDischarged = customer?.isDischarged;

  return (
    <PartnerHeaderContainer>
      <Container>
        <PartnerLogo />
        {location.pathname !== PATIENT_ORDERS_ROUTE ? (
          <PartnerButton variant="outlined" color="secondary" component={RouterLink} to={PATIENT_ORDERS_ROUTE}>
            Order history
          </PartnerButton>
        ) : null}
        {!isLoading && !isDischarged && location.pathname === PATIENT_ORDERS_ROUTE ? (
          <PartnerButton variant="outlined" color="secondary" component={RouterLink} to={PATIENT_REFILL_ROUTE}>
            Order medication
          </PartnerButton>
        ) : null}
      </Container>
    </PartnerHeaderContainer>
  );
}

export default PartnerHeader;
